import { Table } from "antd";
import React, { useState } from "react";

const ReportTable = ({
  columns,
  data,
  scroll,
  total_records,
  payload,
  paginationCall,
}) => {
  const [pageSize, setPageSize] = useState(10);
  return (
    <div className="report-table">
      <Table
        columns={columns}
        dataSource={data}
        scroll={scroll}
        pagination={{
          total: total_records || 0,
          showSizeChanger: false,
          onChange: (pagee, pageSize) => {
            setPageSize(pageSize);
            paginationCall({
              page: pagee,
              pageSize,
              ...payload,
            });
          },
          pageSize: pageSize,
        }}
      />
    </div>
  );
};

export default ReportTable;
